$('video').addClass('hidden');
var hide_iframe = setInterval(function () {
    $('iframe').addClass('hidden');
}, 100);

function InitiateSpeedDetection()
{
    window.setTimeout(MeasureConnectionSpeed, 1);
};
if (window.addEventListener) {
    window.addEventListener('load', InitiateSpeedDetection, false);
} else if (window.attachEvent) {
    window.attachEvent('onload', InitiateSpeedDetection);
}

function MeasureConnectionSpeed()
{

    let connection = '4g';

    let q_auto = '';

    try {
        connection = navigator.connection.effectiveType;
    } catch (e) {
    }

    switch (connection) {
        case '4g':
            q_auto = 'good'
            break;
        default:
            q_auto = 'bad';
            break;
    }

    setTimeout(() => {

        showResults(q_auto);
        $(document).trigger('page-loaded');
    }, 100);

}

function showResults(q_auto)
{

    // Good 3G 750 KB
    if (q_auto === 'bad') {
        // load image
        sessionStorage.setItem("speed_network", "3g");
        $('html').trigger('speed_network', ["3g"]);
        //Module Video
        $('section.is-video-autoplay').each(function () {
            let image_url = $(this).data('image');
            if (image_url) {
                let html = '<div class="iframe-wrapper"><div class="fullscreen-section bg_img dot_img lazy-load-bg-image" style="background-image: url(' + image_url + ')"></div></div>';
                $(this).find('.fp-tableCell').find('script').remove();

                $(this).find('.cs-iframevideo').css({
                    'backgroundImage' : "url('"+ image_url +"')"
                })

                // $(this).find('.fp-tableCell').find('.iframe-wrapper').remove();
                // $(this).find('.fp-tableCell').find('.video-wrapper').remove();
                //
                // console.log($(this).find('.fp-tableCell').find('.cs-iframevideo'));
                //
                // if ($(this).find('.fp-tableCell').find('.cs-iframevideo')[0]) {
                //     $(this).find('.fp-tableCell').find('.cs-iframevideo').append(html);
                // }
                // if ($(this).find('.fp-tableCell').find('.cs-source-video')[0]) {
                //     $(this).find('.fp-tableCell').find('.cs-source-video').append(html);
                // }
            }
        });

        //Module Free Style
        $('section.cs-free-style.has_video').each(function () {
            let image_url = $(this).data('image');
            if (image_url) {
                let html = '<div class="fullscreen-section bg_img dot_img lazy-load-bg-image" style="background-image: url(' + image_url + ')"></div>';
                $(this).find('.free-style').find('video').remove();
                $(this).find('.free-style').append(html);
            }
        });

        //Module Enquire
        $('section.csEnquire').each(function () {
            let image_url = $(this).data('image');
            $(this).find('.carousel-enquire').find('.cs-opacity').each(function (index, el) {
                let image_url_child = $(el).data('image');
                if (!image_url_child) {
                    image_url_child = image_url;
                }
                let html = '<div class="fullscreen-section bg_img dot_img lazy-load-bg-image" style="background-image: url(' + image_url_child + ')"></div>';
                $(el).find('video').remove();
                $(el).append(html);
            });
        });
    } else {
        // load youtube
        sessionStorage.setItem("speed_network", "");
        $('html').trigger('speed_network', [""]);
    }
    clearInterval(hide_iframe);
    $('video').removeClass('hidden');
    $('iframe').removeClass('hidden');
}
